import { FlowContainer } from '../../../../../services/types/Flow';
import { ApiState, Action } from '../../../../../types';
import { serviceReducer } from '../../../../../shared/hooks/serviceReducer';

const esmrReducer = (
  state: ApiState<FlowContainer, number>,
  action: Action<FlowContainer, number>
): ApiState<FlowContainer, number> => serviceReducer(state, action);

export default esmrReducer;
